export const isTokenValid = (token: string | null): boolean => {
  if (!token) return false;

  try {
    const [, payloadBase64] = token.split('.');
    if (!payloadBase64) return false;

    const normalized = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + (4 - (normalized.length % 4)) % 4, '=');

    const payloadJson = atob(padded);
    const payload = JSON.parse(payloadJson);

    if (!payload.exp) return false;

    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    return payload.exp > currentTimeInSeconds;
  } catch (error) {
    console.error('Failed to validate token', error);
    return false;
  }
};

export const clearAdminAuth = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_username');
};

